module.exports = __webpack_public_path__ + "static/media/NokiaPureTWeb_Lt.abb1b26d.ttf";